import { motion, type MotionProps } from "framer-motion"

export function GreenPylon(props: MotionProps) {
    return (
        <motion.svg
            xmlns="http://www.w3.org/2000/svg"
            width={157}
            height={255}
            fill="none"
            animate="visible"
            {...props}
        >
            <motion.g
                stroke="#18F0B8"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                opacity={0.4}
            >
                <motion.path
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    viewport={{ once: true, amount: 0.9 }}
                    transition={{
                        duration: 2,
                    }}
                    d="M152.537 167.809v11.505M43.808 199.719l78.436 53.959-14.514-55.198-7.89-29.963-7.534-146.15L75.97 1 60.876 22.366l-8.774 145.746-22.479 85.743 78.107-55.375"
                />
                <motion.path
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    viewport={{ once: true, amount: 0.9 }}
                    transition={{
                        duration: 2,
                    }}
                    d="m60.876 22.367 31.48 32.037-34.515 32.87L96.58 122.65l-44.477 45.463 59.724 45.995"
                />
                <motion.path
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    viewport={{ once: true, amount: 0.9 }}
                    transition={{
                        duration: 2,
                    }}
                    d="M92.306 22.367 60.118 54.934l34.16 33.428-38.434 34.085 43.997 46.07-59.8 45.59"
                />
                <motion.path
                    initial={{ pathLength: 0 }}
                    whileInView={{ pathLength: 1 }}
                    viewport={{ once: true, amount: 0.9 }}
                    transition={{
                        duration: 10,
                    }}
                    d="m53.57 139.033-15.905 9.179-33.908 19.596 47.511-.455-13.603-19.141M1 179.996h7.004M3.833 167.81v11.504M56.78 90.435l-17.245 9.963-33.933 19.596h48.674l-14.741-19.596M2.845 132.181h7.004M5.678 119.994v11.505M60.117 40.521 41.381 51.343 7.473 70.94H55.92L41.38 51.343M4.716 83.127h6.979M7.549 70.94v11.505M98.248 137.769l18.509 10.443 35.804 19.596H99.967l16.79-19.596M156.001 179.996h-7.384M95.797 90.006l18.989 10.392 35.83 19.596H98.679l16.107-19.596M153.575 132.181h-7.384M150.59 119.994v11.505M93.242 40.622l19.596 10.721 35.805 19.597H97.035l15.803-19.597M151.6 83.127h-7.383M148.617 70.94v11.505"
                />
            </motion.g>
        </motion.svg>
    )
}
